import { rest } from "lodash";

export const PencilIcon = ({ ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...rest}
  >
    <rect
      width="7"
      height="4"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 19.1526 14.2026)"
      fill="#4EA5FF"
      stroke="white"
      strokeLinejoin="round"
    />
    <path
      d="M12.435 5.36396L2.53551 2.53553L5.36394 12.435L12.7886 17.7383L15.2634 15.2635L17.7383 12.7886L12.435 5.36396Z"
      fill="#4EA5FF"
    />
    <path
      d="M2.53551 2.53553L12.435 5.36396L17.7383 12.7886L15.2634 15.2635L12.7886 17.7383L5.36394 12.435L2.53551 2.53553ZM2.53551 2.53553L8.19237 8.19239"
      stroke="white"
      strokeLinejoin="round"
    />
    <circle
      cx="1.5"
      cy="1.5"
      r="1.5"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 9.25293 7.13184)"
      fill="#4EA5FF"
      stroke="white"
    />
  </svg>
);

export const FavoriteTrue = ({ ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...rest}
  >
    <path
      d="M7.55163 0.908492C7.73504 0.536869 8.26496 0.53687 8.44837 0.908493L10.5287 5.1237C10.6015 5.27127 10.7423 5.37356 10.9052 5.39722L15.5569 6.07316C15.967 6.13276 16.1308 6.63674 15.834 6.92601L12.468 10.2071C12.3501 10.322 12.2964 10.4875 12.3242 10.6497L13.1188 15.2826C13.1889 15.6911 12.7601 16.0026 12.3933 15.8097L8.23267 13.6223C8.08701 13.5457 7.91299 13.5457 7.76733 13.6223L3.60667 15.8097C3.23985 16.0026 2.81114 15.6911 2.88119 15.2826L3.67581 10.6497C3.70363 10.4875 3.64985 10.322 3.53201 10.2071L0.165966 6.92601C-0.130793 6.63674 0.0329629 6.13276 0.443073 6.07316L5.09483 5.39722C5.25769 5.37356 5.39847 5.27127 5.4713 5.1237L7.55163 0.908492Z"
      fill="#1D1D39"
    />
  </svg>
);

export const FavoriteFalse = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
  >
    <path
      d="M8.55163 0.908492C8.73504 0.536869 9.26496 0.53687 9.44837 0.908493L11.5287 5.1237C11.6015 5.27127 11.7423 5.37356 11.9052 5.39722L16.5569 6.07316C16.967 6.13276 17.1308 6.63674 16.834 6.92601L13.468 10.2071C13.3501 10.322 13.2964 10.4875 13.3242 10.6497L14.1188 15.2826C14.1889 15.6911 13.7601 16.0026 13.3933 15.8097L9.23267 13.6223C9.08701 13.5457 8.91299 13.5457 8.76733 13.6223L4.60667 15.8097C4.23985 16.0026 3.81114 15.6911 3.88119 15.2826L4.67581 10.6497C4.70363 10.4875 4.64985 10.322 4.53201 10.2071L1.16597 6.92601C0.869207 6.63674 1.03296 6.13276 1.44307 6.07316L6.09483 5.39722C6.25769 5.37356 6.39847 5.27127 6.4713 5.1237L8.55163 0.908492Z"
      fill="white"
      stroke="#1D1D39"
    />
  </svg>
);

export const DotsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z"
      fill="#1D1D39"
    />
  </svg>
);

export const RectangleIcon = ({ ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="6"
    viewBox="0 0 8 6"
    fill="none"
    {...rest}
  >
    <path
      d="M4.30413 5.35815C4.13809 5.54728 3.86191 5.54728 3.69587 5.35815L0.118775 1.28341C-0.13924 0.989495 0.050787 0.5 0.422902 0.5L7.5771 0.5C7.94921 0.5 8.13924 0.989495 7.88122 1.28341L4.30413 5.35815Z"
      fill="#1D1D39"
    />
  </svg>
);

export const DownloadIcon = ({ ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...rest}
  >
    <path
      d="M4 6C4 5.05719 4 4.58579 4.29289 4.29289C4.58579 4 5.05719 4 6 4H18C18.9428 4 19.4142 4 19.7071 4.29289C20 4.58579 20 5.05719 20 6V18C20 18.9428 20 19.4142 19.7071 19.7071C19.4142 20 18.9428 20 18 20H6C5.05719 20 4.58579 20 4.29289 19.7071C4 19.4142 4 18.9428 4 18V6Z"
      stroke="#4EA5FF"
      strokeLinejoin="round"
    />
    <path
      d="M20 15H16L15 17H9L8 15H4"
      stroke="#4EA5FF"
      strokeLinejoin="round"
    />
    <path
      d="M10 11L12 13M12 13L14 11M12 13L12 7"
      stroke="#4EA5FF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EyeVisible = ({ ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...rest}
  >
    <path
      d="M12 7C8.1944 7 5.74654 9.71549 4.22584 11.7018C4.09075 11.8782 4.09075 12.1218 4.22584 12.2982C5.74654 14.2845 8.1944 17 12 17C15.8056 17 18.2535 14.2845 19.7742 12.2982C19.9093 12.1218 19.9093 11.8782 19.7742 11.7018C18.2535 9.71549 15.8056 7 12 7Z"
      stroke="#1D1D39"
    />
    <circle cx="12" cy="12" r="2.5" stroke="#1D1D39" />
  </svg>
);

export const EyeInvisible = ({ ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...rest}
  >
    <path
      d="M4 11C4.73805 11.9841 5.7182 13.2102 7 14.202M20 11C19.262 11.9841 18.2818 13.2102 17 14.202M12 16V18.5M12 16C14.0319 16 15.6767 15.2259 17 14.202M12 16C9.96813 16 8.32331 15.2259 7 14.202M17 14.202L19 16.5M7 14.202L5 16.5"
      stroke="#1D1D39"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DashboardIcon = ({ ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    {...rest}
  >
    <path
      d="M5.875 10.5455L12.875 4L19.875 10.5455V20H15.375V15H12.875H10.375V20H5.875V10.5455Z"
      fill="white"
      stroke="#1D1D39"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchIcon = ({ ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M10.8466 11.2636C11.9447 10.1762 12.625 8.66752 12.625 7C12.625 3.68629 9.93871 1 6.625 1C3.31129 1 0.625 3.68629 0.625 7C0.625 10.3137 3.31129 13 6.625 13C8.27118 13 9.76253 12.337 10.8466 11.2636ZM10.8466 11.2636L16.625 17"
      stroke="#A5A5B0"
      strokeLinecap="round"
    />
  </svg>
);

export const TemplatesIcon = ({ ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    {...rest}
  >
    <mask id="path-1-inside-1_547_5648" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.375 8C5.92728 8 6.375 7.55228 6.375 7C6.375 6.44772 5.92728 6 5.375 6C4.82272 6 4.375 6.44772 4.375 7C4.375 7.55228 4.82272 8 5.375 8ZM8.375 6.5C8.09886 6.5 7.875 6.72386 7.875 7C7.875 7.27614 8.09886 7.5 8.375 7.5H20.375C20.6511 7.5 20.875 7.27614 20.875 7C20.875 6.72386 20.6511 6.5 20.375 6.5H8.375ZM5.375 13C5.92728 13 6.375 12.5523 6.375 12C6.375 11.4477 5.92728 11 5.375 11C4.82272 11 4.375 11.4477 4.375 12C4.375 12.5523 4.82272 13 5.375 13ZM8.375 11.5C8.09886 11.5 7.875 11.7239 7.875 12C7.875 12.2761 8.09886 12.5 8.375 12.5H20.375C20.6511 12.5 20.875 12.2761 20.875 12C20.875 11.7239 20.6511 11.5 20.375 11.5H8.375ZM6.375 17C6.375 17.5523 5.92728 18 5.375 18C4.82272 18 4.375 17.5523 4.375 17C4.375 16.4477 4.82272 16 5.375 16C5.92728 16 6.375 16.4477 6.375 17ZM7.875 17C7.875 16.7239 8.09886 16.5 8.375 16.5H20.375C20.6511 16.5 20.875 16.7239 20.875 17C20.875 17.2761 20.6511 17.5 20.375 17.5H8.375C8.09886 17.5 7.875 17.2761 7.875 17Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.375 8C5.92728 8 6.375 7.55228 6.375 7C6.375 6.44772 5.92728 6 5.375 6C4.82272 6 4.375 6.44772 4.375 7C4.375 7.55228 4.82272 8 5.375 8ZM8.375 6.5C8.09886 6.5 7.875 6.72386 7.875 7C7.875 7.27614 8.09886 7.5 8.375 7.5H20.375C20.6511 7.5 20.875 7.27614 20.875 7C20.875 6.72386 20.6511 6.5 20.375 6.5H8.375ZM5.375 13C5.92728 13 6.375 12.5523 6.375 12C6.375 11.4477 5.92728 11 5.375 11C4.82272 11 4.375 11.4477 4.375 12C4.375 12.5523 4.82272 13 5.375 13ZM8.375 11.5C8.09886 11.5 7.875 11.7239 7.875 12C7.875 12.2761 8.09886 12.5 8.375 12.5H20.375C20.6511 12.5 20.875 12.2761 20.875 12C20.875 11.7239 20.6511 11.5 20.375 11.5H8.375ZM6.375 17C6.375 17.5523 5.92728 18 5.375 18C4.82272 18 4.375 17.5523 4.375 17C4.375 16.4477 4.82272 16 5.375 16C5.92728 16 6.375 16.4477 6.375 17ZM7.875 17C7.875 16.7239 8.09886 16.5 8.375 16.5H20.375C20.6511 16.5 20.875 16.7239 20.875 17C20.875 17.2761 20.6511 17.5 20.375 17.5H8.375C8.09886 17.5 7.875 17.2761 7.875 17Z"
      fill="#A5A5B0"
    />
    <path
      d="M5.375 7V9C6.47957 9 7.375 8.10457 7.375 7H5.375ZM5.375 7H7.375C7.375 5.89543 6.47957 5 5.375 5V7ZM5.375 7V5C4.27043 5 3.375 5.89543 3.375 7H5.375ZM5.375 7H3.375C3.375 8.10457 4.27043 9 5.375 9V7ZM8.875 7C8.875 7.27614 8.65114 7.5 8.375 7.5V5.5C7.54657 5.5 6.875 6.17157 6.875 7H8.875ZM8.375 6.5C8.65114 6.5 8.875 6.72386 8.875 7H6.875C6.875 7.82843 7.54657 8.5 8.375 8.5V6.5ZM20.375 6.5H8.375V8.5H20.375V6.5ZM19.875 7C19.875 6.72386 20.0989 6.5 20.375 6.5V8.5C21.2034 8.5 21.875 7.82843 21.875 7H19.875ZM20.375 7.5C20.0989 7.5 19.875 7.27614 19.875 7H21.875C21.875 6.17157 21.2034 5.5 20.375 5.5V7.5ZM8.375 7.5H20.375V5.5H8.375V7.5ZM5.375 12V14C6.47957 14 7.375 13.1046 7.375 12H5.375ZM5.375 12H7.375C7.375 10.8954 6.47957 10 5.375 10V12ZM5.375 12V10C4.27043 10 3.375 10.8954 3.375 12H5.375ZM5.375 12H3.375C3.375 13.1046 4.27043 14 5.375 14V12ZM8.875 12C8.875 12.2761 8.65114 12.5 8.375 12.5V10.5C7.54657 10.5 6.875 11.1716 6.875 12H8.875ZM8.375 11.5C8.65114 11.5 8.875 11.7239 8.875 12H6.875C6.875 12.8284 7.54657 13.5 8.375 13.5V11.5ZM20.375 11.5H8.375V13.5H20.375V11.5ZM19.875 12C19.875 11.7239 20.0989 11.5 20.375 11.5V13.5C21.2034 13.5 21.875 12.8284 21.875 12H19.875ZM20.375 12.5C20.0989 12.5 19.875 12.2761 19.875 12H21.875C21.875 11.1716 21.2034 10.5 20.375 10.5V12.5ZM8.375 12.5H20.375V10.5H8.375V12.5ZM5.375 19C6.47957 19 7.375 18.1046 7.375 17H5.375V19ZM3.375 17C3.375 18.1046 4.27043 19 5.375 19V17H3.375ZM5.375 15C4.27043 15 3.375 15.8954 3.375 17H5.375V15ZM7.375 17C7.375 15.8954 6.47957 15 5.375 15V17H7.375ZM8.375 15.5C7.54657 15.5 6.875 16.1716 6.875 17H8.875C8.875 17.2761 8.65114 17.5 8.375 17.5V15.5ZM20.375 15.5H8.375V17.5H20.375V15.5ZM21.875 17C21.875 16.1716 21.2034 15.5 20.375 15.5V17.5C20.0989 17.5 19.875 17.2761 19.875 17H21.875ZM20.375 18.5C21.2034 18.5 21.875 17.8284 21.875 17H19.875C19.875 16.7239 20.0989 16.5 20.375 16.5V18.5ZM8.375 18.5H20.375V16.5H8.375V18.5ZM6.875 17C6.875 17.8284 7.54657 18.5 8.375 18.5V16.5C8.65114 16.5 8.875 16.7239 8.875 17H6.875Z"
      fill="#A5A5B0"
      mask="url(#path-1-inside-1_547_5648)"
    />
  </svg>
);

export const MyProjectsIcon = ({ ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    {...rest}
  >
    <path
      d="M4.125 5C4.125 4.44772 4.57272 4 5.125 4H19.125C19.6773 4 20.125 4.44772 20.125 5V10V19C20.125 19.5523 19.6773 20 19.125 20H14.125H5.125C4.57272 20 4.125 19.5523 4.125 19V10V5Z"
      fill="white"
    />
    <path
      d="M4.125 10V19C4.125 19.5523 4.57272 20 5.125 20H14.125M4.125 10V5C4.125 4.44772 4.57272 4 5.125 4H19.125C19.6773 4 20.125 4.44772 20.125 5V10M4.125 10H14.125M20.125 10V19C20.125 19.5523 19.6773 20 19.125 20H14.125M20.125 10H14.125M14.125 10V20"
      stroke="#A5A5B0"
      strokeLinejoin="round"
    />
  </svg>
);
